import React from "react"
import styled from 'styled-components';

//import Button from '@material-ui/core/Button';

const Button = styled.button`
  padding: 0.25em 1em;
  margin: 0;
  margin-top:30px;
  background: #20323f;
  color: #fff;
  border: 0
  width:100%;
  font-size: 12px;
  padding: 15px;
  border-radius:5px !important;
`;

export default class Auth extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            loggedin: false
        }
    }

    componentDidMount(){
      //window.location.reload();

      window.gapi.signin2.render('g-signin2', {
        scope: "https://www.googleapis.com/auth/spreadsheets",
        height: 50,
        width: 200,
        longtitle: false,
        onsuccess: this.onSignIn.bind(this),
        onfailure: this.props.onFailure
      });

    }
    componentWillReceiveProps(props) {
      //console.log("Pre?")
      /*
      window.gapi.signin2.render('g-signin2', {
        scope: "https://www.googleapis.com/auth/spreadsheets",
        height: 50,
        width: 200,
        longtitle: false,
        onsuccess: this.onSignIn.bind(this),
        onfailure: this.props.onFailure
      });
      */
      //console.log("Post?")
    }

    onSignIn(user){
        if (typeof this.props.onSignIn === "function"){
            this.props.onSignIn(user)
        }

        this.setState({
            loggedin: true
        })
    }

    logout(){
        let auth2 = window.gapi.auth2.getAuthInstance();
        auth2.signOut().then(() => {
            this.setState({
                loggedin: false
            })

            if (typeof this.props.onLogout === "function"){
                this.props.onLogout()
            }
        })

    }

    render() {
      return (
        <div>
            <Button style={{display: !this.state.loggedin ? "none" : "inherit"}} variant="outlined" onClick={this.logout.bind(this)}>
                <span className="mdc-button__label">Logout</span>
            </Button>
            <div style={{display: this.state.loggedin ? "none" : "inherit"}} id="g-signin2" data-onsuccess="onSignIn"></div>
        </div>
      )
    };
}



// WEBPACK FOOTER //
// ./src/components/export-google-sheet/components/auth/index.js